import { render } from "./AddModel.vue?vue&type=template&id=5599993a"
import script from "./AddModel.vue?vue&type=script&lang=js"
export * from "./AddModel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__